
import React from "react";

export const CTASection = () => {
  return (
    <div className="mt-20 bg-gradient-purple rounded-2xl p-8 md:p-12 text-white max-w-4xl mx-auto">
      <div className="grid md:grid-cols-5 gap-8 items-center">
        <div className="md:col-span-3">
          <h3 className="text-2xl md:text-3xl font-bold mb-4">
            Your wallet's main character era starts now
          </h3>
          <p className="mb-6 text-white/90">
            Savyi = Your financial chaos, decoded. We're the only app that scans receipts, reads angry letters, and still makes you wanna flex your progress. 💅✨
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <button className="px-6 py-3 bg-white text-savyi-purple font-bold rounded-full hover:bg-white/90 transition">
              Get Early Access
            </button>
          </div>
        </div>
        <div className="md:col-span-2 relative">
          <div className="bg-white/20 backdrop-blur-sm rounded-xl p-6 rotate-3 animate-float">
            <div className="text-center">
              <div className="w-16 h-16 rounded-full bg-white text-savyi-purple flex items-center justify-center mx-auto mb-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                </svg>
              </div>
              <h4 className="text-xl font-bold mb-1">TL;DR</h4>
              <p className="text-white/90 text-sm">
                Imagine budget meets Duolingo, with a PhD in human messiness. Let's talk. 🚀
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
